import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function ProfileAvatar() {
  const [avatar, setAvatar] = useState(() => {
    try {
      return localStorage.getItem("avatar");
    } catch {
      return null;
    }
  });
  const [country, setCountry] = useState(() => {
    try {
      return localStorage.getItem("country");
    } catch {
      return null;
    }
  });
  const [userName, setUserName] = useState(() => {
    try {
      return localStorage.getItem("userName");
    } catch {
      return null;
    }
  });
  const navigate = useNavigate(); // hook to navigate programmatically

  useEffect(() => {
    try {
      setAvatar(localStorage.getItem("avatar"));
      setCountry(localStorage.getItem("country"));
      setUserName(localStorage.getItem("userName"));
    } catch (error) {
      console.warn("localStorage not available:", error);
    }
  }, []);

  const handleClick = () => {
    if (!avatar) {
      navigate("/avatar"); // redirect to avatar selection page
    }
  };

  return avatar ? (
    <div style={{ display: "inline-block", textAlign: "center" }}>
      {/* Avatar + Flag wrapper */}
      <div style={{ position: "relative", display: "inline-block" }}>
        <img
          src={avatar}
          alt="User Avatar"
          style={{ width: "60px", height: "60px", borderRadius: "50%" }}
        />
        {country && (
          <img
            src={`https://flagcdn.com/24x18/${country.toLowerCase()}.png`}
            alt="flag"
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: "16px",
              height: "12px",
              borderRadius: "50%",
              border: "1px solid white",
              boxShadow: "0 0 2px rgba(0,0,0,0.5)",
            }}
          />
        )}
      </div>

      {/* Name below the avatar */}
      {userName && (
        <div style={{ marginTop: "5px", fontSize: "14px", fontWeight: "bold" }}>
          {userName}
        </div>
      )}
    </div>
  ) : (
    <div
      onClick={handleClick}
      style={{
        display: "inline-block",
        cursor: "pointer",
        color: "#black",
        fontWeight: "bold",
        textAlign: "center",
      }}
    >
      No Avatar Selected
    </div>
  );
}

export default ProfileAvatar;
